export const themeConstants = {
    SET_DARK_MODE: 'SET_DARK_MODE',
    STORAGE_KEY: 'isDarkMode'
};
